module.exports = __webpack_public_path__ + "logo-intro.svg?dc46e7eef66611800e48f302509a88d0";